import Vue from 'vue'
import Main from './components/Main.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import vuetify from './plugins/vuetify'
import rules from '@/rules'
import utils from '@/utils'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import {requestAuthenticationRecovery} from '@/authRecovery'

Vue.config.productionTip = false

Vue.use(VueTheMask)

const api = require('axios').create({
  baseURL: process.env.VUE_APP_API || "http://localhost:8000",
  // baseURL: "https://api.v2.datacertify.com.br",
  withCredentials: true,
})
api.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    const authenticationInvalid = error.response
      && error.response.headers['x-auth-invalid'] === '1';
    const requestConfig = error.config || {};
    if (authenticationInvalid && !requestConfig.__authenticationRetried) {
      return requestAuthenticationRecovery().then(
        () => {
          requestConfig.__authenticationRetried = true;
          return api.request(requestConfig);
        },
        () => Promise.reject(error),
      );
    }
    return Promise.reject(error);
  },
)
Vue.prototype.$axios = api
Vue.prototype.$baseURL = process.env.VUE_APP_API || "http://localhost:8000"
Vue.prototype.$rules = rules
Vue.prototype.$utils = utils

new Vue({
  router,
  store,
  vuetify,
  render: h => h(Main)
}).$mount('#app')
